<template>
    <div>

        <div class="modal fade" id="lembreteAtendModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="show_lembrete">
                    <div class="modal-header">
                        <h5 class="modal-title">Lembrete do Atendimento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input type="textarea" v-model="st_lembrete" />

                        <div v-if="marcacao" class="form-row mt-2">
                            <div class="col col-12">
                                <az-input 
                                    label="Sinalizador de Atendimento"
                                    type="select" 
                                    optionsMode="aql"
                                    service="sinalizadores.index"
                                    :optionsParm="{ ativos: true }"
                                    optionsData="id_sinalizador_atendimento"
                                    v-model="marcacao.id_sinalizador_atendimento">
                                </az-input>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-submit color="outline-danger" @click="removerLembrete ()" v-if="atendimento.lembrete && atendimento.lembrete.id_lembrete">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizarLembrete ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            validate: false, 
            show_lembrete: false,
            st_lembrete: "", 
            atendimento: null, 
        };
    },

    components: { 
        AzSubmit,
        AzInput,    
    },

    methods: { 
        abrir (marcacao, atendimento) { 
            this.atendimento = atendimento;
            this.marcacao = marcacao; 

            this.st_lembrete = this.atendimento.lembrete
                ? this.atendimento.lembrete.st_lembrete
                : "";
            this.show_lembrete = true; 
            
            $("#lembreteAtendModal").modal("show");
        },

        removerLembrete() {
            if (!confirm("Confirma remover lembrete?")) {
                return;
            }

            this.$util.remover(this, {
                service: "lembretes",
                dados: this.atendimento.lembrete,
                modal: "lembreteAtendModal",
                callback: () => {
                    this.atendimento.lembrete = null;
                }
            });
        },

        atualizarLembrete() {
            let lembrete;

            if (this.atendimento.lembrete) {
                lembrete = { ...this.atendimento.lembrete };
                lembrete.st_lembrete = this.st_lembrete;

            } else {
                lembrete = {
                    id_lembrete: null
                };
            }

            this.$util.atualizar(this, {
                service: "lembretes",
                dados: { 
                    ...lembrete,
                    id_atendimento: this.atendimento.id_atendimento,
                    st_lembrete: this.st_lembrete,
                    id_marcacao: this.marcacao ? this.marcacao.id_marcacao : null,
                    id_sinalizador_atendimento: this.marcacao ? this.marcacao.id_sinalizador_atendimento : null
                },
                modal: "lembreteAtendModal",
                callback: res => {
                    let sinalizador = res.sinalizador ? res.sinalizador : res.sinalizador_atendimento;
                    
                    if ( sinalizador && this.marcacao ) { 
                        this.marcacao.id_sinalizador_atendimento = sinalizador.id_sinalizador_atendimento;
                        this.marcacao.sinalizador_atendimento = sinalizador;
                    }

                    if ( res && res.status_code > 0 ) { 
                        // 
                    } else { 
                        this.atendimento.lembrete = res;
                    }
                }
            });
        }, 

    }

}
</script>
